import validator from "validator";

const formValidation=()=>{
    return {
        Email:(value)=>validator.isEmail(value)
    }
}
export default formValidation;